import { FC, Fragment, ReactNode, useState } from 'react';
import {
	ArrowUpOutlined,
	ArrowDownOutlined,
	DeleteOutlined,
	MoreOutlined,
	MinusOutlined,
	PlusOutlined,
} from '@ant-design/icons';
import { Button, ButtonProps, Collapse, Dropdown, Empty } from 'antd';

type CollapsibleListProps = {
	readOnly?: boolean;
	accordion?: boolean;
	addButtonProps?: ButtonProps;
	items: {
		label: ReactNode;
		children: ReactNode;
		onRemove?: () => void;
		onMoveUp?: () => void;
		onMoveDown?: () => void;
	}[];
	onAddNew?: () => void;
};

const ADD_BUTTON_PROPS_DEFAULT: ButtonProps = {
	type: 'dashed',
	children: 'Add New',
};

const CollapsibleList: FC<CollapsibleListProps> = ({
	items = [],
	accordion = true,
	readOnly = false,
	addButtonProps = ADD_BUTTON_PROPS_DEFAULT,
	onAddNew,
}) => {
	const [activeKey, setActiveKey] = useState<string[]>([]);

	const handleAdd = () => {
		onAddNew?.();
		setActiveKey((keys) => {
			const newKey = items.length.toString();
			return accordion ? [newKey] : [...keys, newKey];
		});
	};

	return items.length ? (
		<Fragment>
			<Collapse
				size="small"
				expandIconPosition="start"
				accordion={accordion}
				expandIcon={({ isActive }) => (
					<span style={{ marginLeft: 4 }}>
						{isActive ? <MinusOutlined /> : <PlusOutlined />}
					</span>
				)}
				items={items.map((item, index) => {
					const key = index.toString();
					const { label, children, onRemove, onMoveUp, onMoveDown } = item;

					return {
						key,
						label,
						children: <div style={{ padding: 4 }}>{children}</div>,
						extra: !readOnly && (
							<Dropdown
								trigger={['click']}
								menu={{
									onClick: ({ domEvent }) => domEvent.stopPropagation(),
									// onClickCapture: (event) => {
									//   if (!(event.target as HTMLElement).classList.contains("ant-dropdown-menu-item")) {
									//     event.stopPropagation()
									//   }
									// },
									items: [
										{
											key: 1,
											label: 'Move Up',
											icon: <ArrowUpOutlined />,
											disabled: !index,
											onClick: () => {
												if (activeKey.includes(key)) {
													setActiveKey([(index - 1).toString()]);
												}
												onMoveUp?.();
											},
										},
										{
											key: 2,
											label: 'Move Down',
											icon: <ArrowDownOutlined />,
											disabled: index === items.length - 1,
											onClick: () => {
												if (activeKey.includes(key)) {
													setActiveKey([(index + 1).toString()]);
												}
												onMoveDown?.();
											},
										},
										{
											type: 'divider',
										},
										{
											key: 3,
											label: 'Remove',
											icon: <DeleteOutlined />,
											danger: true,
											onClick: () => onRemove?.(),
										},
									],
								}}
							>
								<Button
									size="small"
									shape="circle"
									onClick={(e) => e.stopPropagation()}
									icon={<MoreOutlined />}
								/>
							</Dropdown>
							// <Space size="small">
							//   <Button.Group size="small">
							//     <Button
							//       icon={<CaretUpOutlined />}
							//       disabled={!index}
							//       title="Move Up"
							//       onClick={(e) => {
							//         e.stopPropagation();
							//         if (activeKey.includes(key)) {
							//           setActiveKey([(index - 1).toString()]);
							//         }
							//         onMoveUp?.();
							//       }}
							//     />
							//     <Button
							//       icon={<CaretDownOutlined />}
							//       disabled={index === items.length - 1}
							//       title="Move Down"
							//       onClick={(e) => {
							//         e.stopPropagation();
							//         if (activeKey.includes(key)) {
							//           setActiveKey([(index + 1).toString()]);
							//         }
							//         onMoveDown?.();
							//       }}
							//     />
							//   </Button.Group>

							//   <Popconfirm
							//     title="Remove Entry"
							//     description="Are you sure to remove this entry?"
							//     okText="Remove"
							//     okType="danger"
							//     cancelText="Cancel"
							//     onConfirm={(e) => {
							//       e?.stopPropagation();
							//       onRemove?.();
							//     }}
							//     onCancel={(e) => {
							//       e?.stopPropagation();
							//     }}
							//   >
							//     <Button
							//       size="small"
							//       shape="circle"
							//       onClick={(e) => {
							//         e.stopPropagation();
							//       }}
							//       icon={(
							//         <MoreOutlined />
							//       )}
							//     />
							//   </Popconfirm>
							// </Space>
						),
					};
				})}
				activeKey={activeKey}
				onChange={(keys) => {
					setActiveKey(keys as string[]);
				}}
			/>

			{!readOnly && (
				<Button
					{...ADD_BUTTON_PROPS_DEFAULT}
					{...addButtonProps}
					style={{
						marginTop: 16,
						...addButtonProps?.style,
					}}
					onClick={handleAdd}
				/>
			)}
		</Fragment>
	) : (
		<Empty
			style={{
				marginInline: 0,
			}}
		>
			{!readOnly && (
				<Button
					{...ADD_BUTTON_PROPS_DEFAULT}
					{...addButtonProps}
					onClick={handleAdd}
				/>
			)}
		</Empty>
	);
};

export default CollapsibleList;
